import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { RenewalsReport } from "@/features/office/reports/homecare-renewals";
import { maskSearchFragment } from "@/features/shared/route-masking";

// Lenient URL schema (strict enums on URL params crash the page — see
// webapp-routing.md). `tab` picks HomeCare plans (absent) or first
// anniversaries, `view` is the tile the desk is narrowed to, `market` the
// market switch's pick (absent = every market), `search` the list's search
// box.
const searchSchema = z.object({
  tab: z.string().optional().catch(undefined),
  view: z.string().optional().catch(undefined),
  market: z.string().optional().catch(undefined),
  search: z.string().optional().catch(undefined),
  ...maskSearchFragment,
});

export const routeId = "/office/reports/homecare-renewals";
export const Route = createFileRoute("/office/reports/homecare-renewals")({
  validateSearch: searchSchema,
  component: RenewalsReport,
});
